/**
 * Company: SPHMedia
 * Description: LifestyleCard Component
 */

import { ReactElement } from "react";
import { RouteFactory } from "@app/routePaths";
import { BasicCardProps } from "@components/ArticleCard/types";
import Category from "@components/ArticleMeta/Category";
import Description from "@components/ArticleMeta/Description";
import Kicker from "@components/ArticleMeta/Kicker";
import ReadMore from "@components/ArticleMeta/ReadMore";
import SubscriberFlag from "@components/ArticleMeta/SubscriberFlag";
import TitleLink from "@components/ArticleMeta/TitleLink";

/**
 * LifestyleCard
 * Description: [Description of what the component does]
 * @param props - The props required by the component (if any)
 * @returns The rendered React element
 */
export default function LifestyleCard({
  id,
  kicker = "",
  section,
  title = "",
  paywall = false,
  blurb = "",
}: BasicCardProps): ReactElement {
  return (
    <>
      <div className="space-y-2">
        {section?.name ? (
          <Category
            categoryName={section.name}
            rootClassName="text-4xs bg-lifestyle-primary shadow-lightBlue"
            hrefLink={RouteFactory.section(
              section.uniqueName.replace("_", "/")
            )}
          />
        ) : null}

        {kicker && (
          <Kicker name={kicker} rootClassName="font-pt-sans text-gray-515" />
        )}

        <TitleLink
          title={title}
          articleId={id}
          rootClassName="text-6xl lg:text-11xl !leading-[1.2] font-pt-serif text-white"
          linkRootClassName="!inline bg-black-100 shadow-negative"
        />

        {paywall ? (
          <SubscriberFlag rootClassName="leading-1.4 text-4xs font-normal uppercase mt-1 !text-white bg-black-100 shadow-negative" />
        ) : null}

        <Description
          text={blurb}
          rootClassName="text-xl bg-black-100 shadow-negative text-white hidden lg:inline leading-6 mb-4"
        />

        <ReadMore articleId={id} isAnimated />
      </div>
    </>
  );
}
